<div *ngIf="value" class="code-container">
    <div fxLayout="row" fxLayoutGap="10px">
        <div fxFlex>
            <mat-form-field class="field-full-width" appearance="legacy">
                <mat-label>Libellé</mat-label>
                <input matInput [(ngModel)]="value.label">
            </mat-form-field>            
        </div>
        <div fxFlex="100px">
            <mat-form-field class="field-full-width" appearance="legacy">
                <mat-label>Prix</mat-label>
                <input matInput [(ngModel)]="value.price">
            </mat-form-field>            
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="15px">
        <div fxFlex>
            <mat-radio-group [(ngModel)]="value.inamigroup" class="flat-fields">
                <mat-radio-button value="PP">PP</mat-radio-button>
                <mat-radio-button value="AO">OA</mat-radio-button>
                <mat-radio-button value="OMNIO">OMNIO</mat-radio-button>
            </mat-radio-group>
        </div>
        <div fxFlex>
            <section class="flat-fields">
                <mat-checkbox class="field-margin" [(ngModel)]="value.dmg">DMG</mat-checkbox>
                <mat-checkbox class="field-margin" [(ngModel)]="value.chronique">Chronique</mat-checkbox>
                <mat-checkbox class="field-margin" [(ngModel)]="value.stagiaire">Stagiaire</mat-checkbox>
                <mat-checkbox class="field-margin" [(ngModel)]="value.aftermg">Après MG</mat-checkbox>
                <mat-checkbox class="field-margin" [(ngModel)]="value.accredit">Accrédité</mat-checkbox>
            </section>
        </div>
        <div fxFlex="5em">
            <mat-form-field class="field-small-medium">
                <mat-label>De</mat-label>
                <input matInput [(ngModel)]="value.startage">
            </mat-form-field>
        </div>
        <div fxFlex="5em">
            <mat-form-field class="field-small-medium">
                <mat-label>à</mat-label>
                <input matInput [(ngModel)]="value.stopage">
            </mat-form-field>
        </div>
        <div fxFlex>
            <mat-form-field class="field-medium">
                <mat-label>Date début</mat-label>
                <input matInput [value]="value.startdate" (dateChange)="value.startdate = $event.value" [matDatepicker]="pickerStartDate">
                <mat-datepicker-toggle matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerStartDate></mat-datepicker>
            </mat-form-field>  
        </div>
        <div fxFlex>
            <mat-form-field class="field-medium">
                <mat-label>Date fin</mat-label>
                <input matInput [value]="value.stopdate" (dateChange)="value.stopdate = $event.value" [matDatepicker]="pickerStopDate">
                <mat-datepicker-toggle matSuffix [for]="pickerStopDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerStopDate></mat-datepicker>
            </mat-form-field>  
        </div>
        <div fxFlex="80px">
            <button mat-icon-button (click)="saveValue()"><fa-icon [icon]="['fas','save']" size="2x"></fa-icon></button>
            <button mat-icon-button (click)="removeValue()"><fa-icon [icon]="['fas','trash']" size="2x"></fa-icon></button>
        </div>
    </div>
</div>
<div *ngIf="code" class="code-container">
    <div fxLayout="row" fxLayoutGap="10px">
        <div fxFlex="100px">
            <mat-form-field class="field-full-width" appearance="legacy">
                <mat-label>Code</mat-label>
                <input matInput [(ngModel)]="code.value">
            </mat-form-field>            
        </div>
        <div fxFlex>
            <mat-form-field class="field-full-width" appearance="legacy">
                <mat-label>Libellé</mat-label>
                <input matInput [(ngModel)]="code.label">
            </mat-form-field>            
        </div>
        <div fxFlex="100px">
            <mat-form-field class="field-full-width" appearance="legacy">
                <mat-label>Prix</mat-label>
                <input matInput [(ngModel)]="code.price">
            </mat-form-field>            
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="10px">
        <div fxFlex>
            <mat-form-field class="field-full-width" appearance="legacy">
                <mat-label>Description</mat-label>
                <textarea matInput [(ngModel)]="code.description"></textarea>
            </mat-form-field>
        </div>
        <div fxFlex="80px">
            <button mat-icon-button (click)="saveValue()"><fa-icon [icon]="['fas','save']" size="2x"></fa-icon></button>
            <button mat-icon-button (click)="removeValue()"><fa-icon [icon]="['fas','trash']" size="2x"></fa-icon></button>
        </div>
    </div>
</div>